import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {SubmittableDirective} from './directives/submittable.directive';
import {MccDatePipe} from './pipes/mcc-date.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        SubmittableDirective,
        MccDatePipe
    ],
    exports: [
        SubmittableDirective,
        MccDatePipe
    ],
    providers: [
        DatePipe
    ]
})
export class UtilsModule {
}



// WEBPACK FOOTER //
// /app/src/app/modules/utils/utils.module.ts